import React from 'react';
import { useStoreMap } from 'effector-react';
import { ImageType } from '@types';
import Image from '@components/Image';
import useLangString from '@hooks/useLangString';
import { $tourData } from '@stores/dataStores';

export function WSandTableButton() {
  const showBtn = useStoreMap({
    store: $tourData,
    keys: [],
    fn: (data) => !!data.config?.sandBox?.list?.length,
  });
  const lang = useLangString(
    {
      btn: ['进入沙盘', 'Floor Plan'],
    },
    []
  );
  if (!showBtn) return null;
  return (
    <div
      className="mt-15 inline-flex h-30 select-none items-center justify-center rounded px-10"
      style={{
        background: 'linear-gradient(180deg, #FA6400 0%, #FFAE78 100%)',
      }}
    >
      <Image
        src="/imgs/stb-marker.02ce95269e492ca81866b026c4ef8604.png"
        type={ImageType.sysMedia}
        className="mr-5 h-16 w-16"
      />
      <div>{lang.btn}</div>
    </div>
  );
}
